<template>
  <div class="container" :style="{
      backgroundColor:shareData.skinBottomColour,
      backgroundImage: 'url( ' + shareData.skinBottomImg + ')',
      backgroundSize: shareData.stretchingType==1?'100% auto':'cover',
      backgroundRepeat:'no-repeat',
      backgroundPosition:'center top'
    }">
    <div v-if="promotionStatus == 2&&boxShow">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="main">
          <div class="rule" v-if="allData.contentType==0">
            <img
              src="../../../assets/img/shareUniversal/rule.png"
              @click="goRule"
            />
          </div>
          <banner-list :activitySpreadVo="allData.activitySpreadVo"
                       :iconPic="iconPic"></banner-list>
          <!--登录前-->
          <div v-if="allData.activitySpreadVo.beInviteImg">
            <div class="ad-box" v-if="!loginStatus"><img
              :src="allData.activitySpreadVo.beInviteImg"/>
            </div>
          </div>
          <div class="become-btn2"
               @click="becomeFun(shareParam.nodeType==21?'车主':shareParam.nodeType==22?'司机':'')"
               v-if="!loginStatus">
            我要参与
          </div>
          <div class="become-btn"
               @click="becomeFun('立即邀请')"
               v-if="!loginStatus">
            我也要邀请
          </div>
          <!--登录后优惠券奖励&acceptData代表已经登录状态了在下面的获取活动信息处已经做了登录判断接口请求状态-->
          <div v-if="loginStatus">
            <div
              v-if="acceptData.isRegister==1||acceptData.isAuth==1||acceptData.isNewRushOrder==1||acceptData.isOldRushOrder==1||acceptData.allCarOwnerRushOrder==1||acceptData.allDriverRushOrder==1||acceptData.isRegister==2||acceptData.isAuth==2||acceptData.isNewRushOrder==2||acceptData.isOldRushOrder==2||acceptData.allCarOwnerRushOrder==2||acceptData.allDriverRushOrder==2">
              <my-reward-page :paramsData="paramsData" :acceptData="acceptData"></my-reward-page>
            </div>
            <div v-else>
              <div v-if="allData.activitySpreadVo.beInviteImg">
                <div class="ad-box"><img :src="allData.activitySpreadVo.beInviteImg"/></div>
              </div>
              <div class="tips">您已经完成过此活动节点啦！<br>快去邀请其他人参与活动，<span>赢得奖励</span>吧～</div>
              <div class="become-btn" @click="becomeFun('立即邀请')">我也要邀请</div>
            </div>
          </div>
          <!--活动规则-->
          <div class="rule-box" v-if="allData.contentType==1&&allData.content">
            <div class="title"><span><b>活动规则</b></span></div>
            <div v-html="allData.content"></div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
    <!--活动结束-->
    <div v-if="promotionStatus == 4&&boxShow">
      <end-page></end-page>
    </div>
    <!--不符合活动条件显示-->
    <end-active :promotiontype="promotionStatus"
                v-if="promotionStatus != 2&&promotionStatus != 4"></end-active>
    <!--登录弹出层-->
    <select-login :loginShow="loginShow" :paramsData="paramsData"
                  :activityName="activityName"></select-login>
    <div class="ws-slogan">万顺叫车 | 万顺代驾</div>
  </div>
</template>

<script>
  import { getActivityInfo, accept } from '@/apis/activity/common';
  import util from '@/utils/util';
  import BannerList from '../common/bannerList';
  import SelectLogin from '../../../components/common/selectLogin';
  import EndPage from './components/endPage';
  import EndActive from '../common/endActive';
  import wx from 'weixin-js-sdk';
  import MyRewardPage from './components/myRewardPage';

  export default {
    components: {
      MyRewardPage,
      EndActive,
      EndPage,
      SelectLogin,
      BannerList
    },
    data() {
      return {
        paramsData: {},
        promotionStatus: 2, //活动信息 1 待开始 2 活动中 3 已下架 4 已结束 5 不满足城市要求 6 不满足活动人群要求
        isLoading: false,
        loginShow: false,//登录选择
        activityName: 'goBack',//登录注册完后，注识可返回注册登录页，知道从哪个地方哪，回哪去
        allData: {},//活动基础信息
        // bottomPic: '',
        iconPic: '',
        acceptData: {},
        shareParam: {},
        driverId: null,
        loginStatus: false,//登录状态
        boxShow: false,//页面加载完再展示
        shareData: {},

        browseTime: 0,  // 浏览时长初始值为 0
        clearTimeSet: null,
      };
    },

    created() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      let userInfoDjsj = this.$storage.getSession('userInfoDjsj') || {};
      this.driverId = userInfoDjsj.driverId;
      console.log(this.driverId, '代驾司机id');
      console.log(this.$route.query, 'this.$route.querythis.$route.querythis.$route.query');
      this.paramsData = this.$apiFun.getPlatFromParams(this.$route.query);
      if (this.paramsData) {
        this.getDataFromNative();
      } else {
        this.$apiFun.getUserInfoFromApp();
      }
    },
    destroyed() {
      clearInterval(this.clearTimeSet); // 离开页面后清除定时器---埋点
      sensors.track('ActivitiesView', {
        event_duration: this.browseTime,//浏览时长
      });
    },
    methods: {
      //埋点记时
      setTime() {
        //设置定时器
        this.clearTimeSet = setInterval(() => {
          this.browseTime++;
          // console.log(this.browseTime, "时长累计");
        }, 1000);
      },
      //刷新页面
      onRefresh() {
        setTimeout(() => {
          this.$toast('刷新成功');
          this.isLoading = false;
          this.getActivityInfoFun();
        }, 500);
      },
      // APP交互后获取params IosAndroid必须用这个方法名定义的哦，和挂载的要一样才行~所以所小程序的也噌用它的方法名为保统一
      getDataFromNative(params) {
        if (params) {
          this.paramsData = this.$apiFun.getParamsIosAndroid(params, this.$route.query);
        }
        console.log(this.paramsData, '平台获取到的公参与入参');
        //获取活动信息
        this.getActivityInfoFun();
      },
      //获取活动信息
      async getActivityInfoFun() {
        let params = { ...this.paramsData.params };
        let paramsOther = this.paramsData.paramsOther;
        let shareParam = paramsOther.shareParam ? JSON.parse(paramsOther.shareParam) : {};
        this.shareParam = shareParam;
        params.data = util.filterParams({
          activityId: paramsOther.activityId,
          cityCode: paramsOther.cityCode,
          distributionCode: paramsOther.outreachChannelCode,
          realChannelId: shareParam.realChannelId,
          driverId: this.shareParam.nodeType == 22 && this.driverId ? this.driverId : null,//根据产品变动，后台逻辑，每次到这个页面也就不存在driverId
        });
        params.data = JSON.stringify(params.data);
        try {
          const data = await getActivityInfo(params);
          if (data.code == 1) {
            let datas = JSON.parse(data.data);
            //埋点
            this.setTime(); // 页面加载完成后开始计时
            let appName;
            if ((paramsOther.source == 200 || paramsOther.source == 800 || paramsOther.source == 900) && (this.paramsData.params == 1 || this.paramsData.params == 2)) {
              appName = 1;
            } else if (paramsOther.source == 801 && (this.paramsData.params == 1 || this.paramsData.params == 2)) {
              appName = 3;
            } else if (this.paramsData.params == 4) {
              appName = 4;
            } else if (paramsOther.source == 200 && this.paramsData.params == 3) {
              appName = 5;
            } else if (paramsOther.source == 800 && this.paramsData.params == 3) {
              appName = 6;
            } else if (paramsOther.source == 900 && this.paramsData.params == 3) {
              appName = 7;
            } else {
              appName = 6;
            }
            let att = util.filterParams({
              user_id: this.driverId ? this.driverId : params.passengerId,//用户ID
              app_name: appName,//应用名称
              activity_id: paramsOther.activityId,//活动ID
              activity_url: datas.name,//活动名称
              user_invite_type: 2,//1邀请人 2被邀请人
              activities_type: 8,//1拼团活动,2抽奖活动,3完单活动,4签到活动,5天降福袋活动,6兑换活动,7送如意活动,8邀请活动,9自主完成车主认证活动,10裂变活动,11车票活动,12通用领券活动,13宣传页面活动,14女性安全传播活动,15渠道商扫码活动,16冒泡折扣活动
            });
            sensors.track('ActivitiesView', att);
            //页面渲染字段
            document.getElementsByTagName('title')[0].innerText = datas.name;
            this.$route.meta.title = datas.name;
            // 活动状态 1 待开始 2 活动中 3 已下架 4 已结束 5 不满足城市要求 6 不满足活动人群要求
            this.promotionStatus = datas.promotionStatus;
            this.allData = datas;
            if (datas.activitySpreadVo) {
              this.shareData = datas.activitySpreadVo;
            }
            this.boxShow = true;//加载完再展示
            this.$toast.clear();
            //接受邀请-登陆后接受邀请---需要做角色判断
            if ((this.shareParam.nodeType == 21 && this.paramsData.params.passengerId) || (this.shareParam.nodeType == 22 && this.driverId)) {
              this.loginStatus = true;
              this.acceptFun();
            } else {
              this.loginStatus = false;
            }
          }
        } catch (error) {
        }
      },
      // 接受邀请-登陆后接受邀请
      async acceptFun() {
        console.log(this.paramsData, 'dfdfd');
        let params = { ...this.paramsData.params };
        let paramsOther = this.paramsData.paramsOther;
        params.data = util.filterParams({
          activityId: paramsOther.activityId,//活动id
          cityCode: +this.shareParam.isCityCode,//邀请人城市
          userId: this.shareParam.userId,//邀请人userId
          beCityCode: paramsOther.cityCode,//被邀请人城市(本人)
          beUserId: this.shareParam.nodeType == 22 && this.driverId ? this.driverId : params.passengerId,//被邀请人id
          nodeType: +this.shareParam.nodeType,//1邀请车主 2邀请乘客 3邀请代驾司机 4邀请代驾车主
        });
        params.data = JSON.stringify(params.data);
        try {
          const data = await accept(params);
          if (data.code == 1) {
            if (JSON.parse(data.data).msg) {
              this.$toast(JSON.parse(data.data).msg);
            }
            this.acceptData = JSON.parse(data.data).activityInvite;
          }
        } catch (error) {
        }
      },
      //跳转活动规则
      goRule() {
        this.$router.push({
          name: 'toActivityRules',
          query: {
            activityId: this.paramsData.paramsOther.activityId,
            cityCode: this.paramsData.paramsOther.cityCode,
          },
        });
      },
      //成为代驾按钮事件
      becomeFun(val) {
        if (val == '司机') {
          this.loginShow = true;
        } else if (val == '车主') {
          this.$router.push({
            path: '/home/myReward',
            query: this.$route.query,
          });
        } else {
          let query = this.$route.query;
          if (this.shareParam.nodeType == 22) {
            if (this.driverId) {
              query.driverId = this.driverId;
              this.$router.push({
                name: 'shareUniversal',
                query: query,
              });
            } else {
              this.loginShow = true;
            }
          } else {
            this.$router.push({
              name: 'shareUniversal',
              query: query,
            });
          }

        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .container {
    /*background: #FEF7E7;*/
    position: relative;

    .ws-slogan {
      text-align: center;
      padding: 20px 0;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 46, 42, 0.3);
      line-height: 22px;
    }

    .main {
      .rule {
        position: absolute;
        right: 0;
        top: 90px;
        z-index: 9999;

        img {
          width: 77px;
          height: 42px;
        }
      }

      .rule-box {
        padding: 20px 14px 0 14px;
        font-size: 12px;
        font-weight: 400;
        color: #8C5C2E;
        line-height: 20px;

        .title {
          text-align: center;
          padding-bottom: 24px;

          span {
            background: url("../../../assets/img/shareUniversal/bg-rule001.png") no-repeat left center;
            padding-left: 40px;
          }

          b {
            font-size: 18px;
            font-weight: 400;
            color: #000000;
            line-height: 26px;
            letter-spacing: 1px;
            background: url("../../../assets/img/shareUniversal/bg-rule002.png") no-repeat right center;
            padding-right: 40px;
          }
        }
      }

    }

    .ad-box {
      background: #FFFFFF;
      box-shadow: 0px 1px 6px 0px #FFE3CF;
      border-radius: 12px;
      margin: 32px 10px;

      img {
        border-radius: 12px;
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .tips {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align: center;
      padding: 0 32px 0 32px;
      /*padding: 0 32px 60px 32px;*/

      span {
        color: #FE0703;
      }
    }

    .become-btn {
      background: linear-gradient(180deg, #FFF9D6 0%, #FFC969 100%);
      box-shadow: 0px 4px 10px 0px rgba(255, 166, 150, 0.82);
      border-radius: 25px;
      font-size: 20px;
      font-weight: 600;
      color: #906000;
      line-height: 28px;
      text-shadow: 0px 2px 3px #DB8C00;
      padding: 11px 0;
      /*margin: 24px 24px 5px 24px;*/
      margin: 24px 24px 10px 24px;
      text-align: center;
    }

    .become-btn2 {
      background: linear-gradient(180deg, #FFDF88 0%, #FF8E64 25%, #FE0602 100%);
      box-shadow: 0px 4px 10px 0px #FF9E96;
      border-radius: 25px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 28px;
      text-shadow: 0px 2px 1px #CD0007;
      padding: 11px 0;
      margin: 46px 24px 0 24px;
      text-align: center;
    }
  }

</style>
